import { Cache } from "memory-cache";
import { StaticStorageClient } from "../service/staticstorageclient";
import { TypeEntity } from ".";
import { Client } from "../service/esiclient";
import { getErrorCount, setErrorcount } from "../helpers/ErrorCache";

//Static storage client
const dataClient = new StaticStorageClient();
const esiClient = new Client();
// Cache
const cache = new Cache();

export async function getCachedTypeEntity(type_id: number): Promise<TypeEntity | null> {
  let entity: any = await cache.get(type_id.toString());
  if (entity) {
    return entity;
  }
  try {
    const type = await dataClient.get_types_type_id(type_id);
    if (type) {
      entity = new TypeEntity(type_id, type);
      cache.put(type_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
      return entity;
    } else {
      let entityfallbackcatch: any = await cache.get("fallback-" + type_id.toString());
      if (entityfallbackcatch === "x") return null;
      let unsafeToFetch = false;
      let everefTypesListCache: any = await cache.get("evereftypes");
      if (everefTypesListCache == null) {
        try {
          const list = await fetch("https://ref-data.everef.net/types");
          const response = await list.json();
          if (response.indexOf(type_id) == -1) unsafeToFetch = true;
          cache.put("evereftypes", response, 60 * 60 * 1000);
        } catch (error) {
          cache.put("evereftypes", "x", 60 * 60 * 1000);
        }
      } else if (everefTypesListCache != "x") {
        if (everefTypesListCache.indexOf(type_id) == -1) unsafeToFetch = true;
      }
      const errorCount = getErrorCount();
      if (parseInt(errorCount.toString()) < 10 || unsafeToFetch) return null;
      try {
        const fallbacktype = await esiClient.get_universe_types_type_id(null, null, null, null, type_id);
        if (fallbacktype !== null) {
          entity = new TypeEntity(type_id, fallbacktype);
          cache.put(type_id.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
          return entity;
        } else {
          cache.put("fallback-" + type_id.toString(), "x", 60 * 60 * 1000 /* 1 hour */);
          return null;
        }
      } catch (error) {
        setErrorcount(1);
        cache.put("fallback-" + type_id.toString(), "x", 60 * 60 * 1000 /* 1 hour */);
        return null;
      }
    }
  } catch (error) {
    console.error(error);
    return null;
  }
}

export async function getTypeByString(
  search: string,
  strict: boolean,
  display_unpublished: boolean
): Promise<TypeEntity[] | null> {
  try {
    const results: any = await dataClient.get_types_by_string(search, strict, display_unpublished);
    if (results !== null) {
      let entityList: TypeEntity[] = [];
      for (let i = 0; i < results.length; i++) {
        const entity = new TypeEntity(results[i].typeID, results[i]);
        cache.put(results[i].typeID.toString(), entity, 60 * 60 * 1000 /* 1 hour */);
        entityList.push(entity);
      }
      return entityList;
    } else {
      return null;
    }
  } catch (e) {
    console.log(e);
    return null;
  }
}
